"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawMainNavigation = void 0;
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const react_router_dom_1 = require("react-router-dom");
const react_transition_group_1 = require("react-transition-group");
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const array_1 = require("../../common/js/helper/array");
const translation_1 = require("../../common/js/helper/translation");
const zuend_logo_svg_1 = __importDefault(require("../../img/zuend-logo.svg"));
const ProductSuggestionDropdown_1 = __importDefault(require("../atoms/ProductSuggestionDropdown"));
const Paths = __importStar(require("../constants/Paths"));
const Routes_1 = __importDefault(require("../constants/Routes"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const Transition_1 = __importDefault(require("../enums/Transition"));
const dataLayer_1 = require("../helper/dataLayer");
const dropdown_1 = require("../helper/dropdown");
const history_1 = require("../helper/history");
const path_1 = require("../helper/path");
const transition_1 = require("../helper/transition");
const NavigationStore_1 = __importDefault(require("../stores/NavigationStore"));
const NotificationStore_1 = __importDefault(require("../stores/NotificationStore"));
const CompanySwitch_1 = __importDefault(require("./CompanySwitch"));
const HelpButtonMainNavigation_1 = __importDefault(require("./help/HelpButtonMainNavigation"));
const MainNavigationItem_1 = __importDefault(require("./MainNavigationItem"));
const NotificationButtonMainNavigation_1 = __importDefault(require("./notifications/NotificationButtonMainNavigation"));
const UserButton_1 = __importDefault(require("./user_button/UserButton"));
class MainNavigation extends react_1.default.Component {
    debouncedSearchInputChanged = (0, debounce_1.debounce)(this.onSearchChange, 500);
    searchInputElement = react_1.default.createRef();
    mobileNavHidden = true;
    mobileSearchHidden = true;
    searchTerm = '';
    suggestedProducts;
    showProductSuggestions = false;
    isSuggestionLoading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            mobileNavHidden: mobx_1.observable,
            mobileSearchHidden: mobx_1.observable,
            searchTerm: mobx_1.observable,
            suggestedProducts: mobx_1.observable,
            showProductSuggestions: mobx_1.observable,
            isSuggestionLoading: mobx_1.observable,
            showSearchButton: mobx_1.computed,
            showNotificationButton: mobx_1.computed,
            onShowProductSuggestions: mobx_1.action.bound,
            toggleMobileNav: mobx_1.action.bound,
            hideMobileNav: mobx_1.action.bound,
        });
    }
    get showSearchButton() {
        const matches = (0, react_router_config_1.matchRoutes)([{ path: Paths.PATH_SHOP }], this.props.location.pathname);
        const firstMatchedPath = (0, array_1.first)(matches)?.route.path ?? null;
        return firstMatchedPath === Paths.PATH_SHOP;
    }
    get showNotificationButton() {
        return NotificationStore_1.default.hasRequiredPermissions;
    }
    componentDidMount() {
        document.addEventListener('click', this.onShowProductSuggestions);
        const matchesSearchRoute = (0, array_1.first)((0, react_router_config_1.matchRoutes)([{ path: Paths.PATH_SHOP_PRODUCTS_SEARCH }], this.props.location.pathname));
        if (matchesSearchRoute?.route.path === Paths.PATH_SHOP_PRODUCTS_SEARCH) {
            (0, mobx_1.runInAction)(() => {
                this.searchTerm = matchesSearchRoute.match.params.searchTerm ?? '';
            });
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onShowProductSuggestions);
    }
    render() {
        return (react_1.default.createElement("aside", { className: "znd-main-navigation" },
            react_1.default.createElement("header", { className: "znd-main-navigation__header" },
                react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths.PATH_HOME) },
                    react_1.default.createElement("img", { src: zuend_logo_svg_1.default, alt: (0, translation_1.t)('main_navigation.logo_alt'), className: "znd-main-navigation__logo" })),
                react_1.default.createElement("div", { className: "znd-main-navigation__buttons" },
                    this.mobileNavHidden ? (react_1.default.createElement("div", { className: "d-none d-md-inline-block d-xl-none align-middle" },
                        react_1.default.createElement(CompanySwitch_1.default, null))) : null,
                    this.showSearchButton ? (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.mobileNavHidden, classNames: Transition_1.default.fade, addEndListener: transition_1.defaultEndListener },
                        react_1.default.createElement("div", { className: "btn znd-main-navigation__search-button", onClick: this.toggleMobileSearch },
                            react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.search })))) : null,
                    this.mobileNavHidden ? react_1.default.createElement(HelpButtonMainNavigation_1.default, null) : null,
                    this.mobileNavHidden && this.showNotificationButton ? (react_1.default.createElement(NotificationButtonMainNavigation_1.default, null)) : null,
                    react_1.default.createElement("div", { className: "btn znd-main-navigation__hamburger", onClick: this.toggleMobileNav },
                        react_1.default.createElement(react_transition_group_1.SwitchTransition, null,
                            react_1.default.createElement(react_transition_group_1.CSSTransition, { key: this.mobileNavHidden ? 1 : 0, classNames: Transition_1.default.fade, addEndListener: transition_1.defaultEndListener },
                                react_1.default.createElement(Icon_1.default, { name: this.mobileNavHidden ? Zupicons_1.default.bars : Zupicons_1.default.close })))))),
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.mobileSearchHidden, classNames: "znd-main-navigation__search--transition", addEndListener: transition_1.defaultEndListener },
                react_1.default.createElement("section", { className: "znd-main-navigation__search" },
                    react_1.default.createElement("div", { className: "btn znd-main-navigation__search-back", onClick: this.hideMobileSearch },
                        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.arrowLeft })),
                    react_1.default.createElement("div", { className: "znd-main-navigation__search-input-wrapper" },
                        react_1.default.createElement("div", { className: "btn znd-main-navigation__search-icon" },
                            react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.search })),
                        react_1.default.createElement("input", { ref: this.searchInputElement, className: "znd-main-navigation__search-input", placeholder: (0, translation_1.t)('main_navigation.search_placeholder'), value: this.searchTerm, onChange: (event) => {
                                (0, mobx_1.runInAction)(() => {
                                    // replacing of % is needed until https://github.com/ReactTraining/history/pull/656 is released in react-router
                                    this.searchTerm = event.target.value
                                        .replace(/[\s]+/g, ' ')
                                        .replace('%', '')
                                        .trim();
                                });
                                this.debouncedSearchInputChanged();
                            }, onKeyUp: (event) => {
                                if (event.key === 'Enter' && this.searchTerm.length >= 2) {
                                    (0, history_1.pushHistory)(this.props.history, Paths.PATH_SHOP_PRODUCTS_SEARCH.replace(':searchTerm', encodeURIComponent(this.searchTerm)));
                                    this.hideMobileSearch();
                                }
                            }, onFocus: () => {
                                this.showProductSuggestions = true;
                            } }),
                        react_1.default.createElement(ProductSuggestionDropdown_1.default, { showDropdown: this.showProductSuggestions, suggestedProducts: this.suggestedProducts, onClick: this.onSuggestionClick }),
                        react_1.default.createElement("div", { className: "btn znd-main-navigation__search-clear", onClick: this.onSearchClear },
                            react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.closeAlt }),
                            this.isSuggestionLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-loading-spinner--small znd-loading-spinner--position-absolute znd-main-navigation__loading" })) : null)))),
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.mobileSearchHidden, classNames: "znd-main-navigation__backdrop-search--transition", addEndListener: transition_1.defaultEndListener },
                react_1.default.createElement("div", { className: "znd-main-navigation__backdrop-search", onClick: this.hideMobileSearch })),
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.mobileNavHidden, classNames: "znd-main-navigation__content--transition", addEndListener: transition_1.defaultEndListener },
                react_1.default.createElement("div", { className: "znd-main-navigation__backdrop-nav", onClick: this.hideMobileNav })),
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.mobileNavHidden, classNames: "znd-main-navigation__content--transition", addEndListener: transition_1.defaultEndListener },
                react_1.default.createElement("section", { className: "znd-main-navigation__content" },
                    react_1.default.createElement("nav", { className: "znd-main-navigation__nav" }, NavigationStore_1.default.items.map((item) => (react_1.default.createElement(MainNavigationItem_1.default, { key: item.uuid, item: item, active: this.isActive(item), onItemClick: () => {
                            (0, dataLayer_1.pushToDataLayerNavigation)({
                                [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)(item.title),
                            });
                            this.hideMobileNav();
                        } })))),
                    react_1.default.createElement("div", { className: "znd-main-navigation__user" },
                        react_1.default.createElement(UserButton_1.default, { onItemClick: this.hideMobileNav }),
                        react_1.default.createElement("div", { className: "d-md-none mt-3" },
                            react_1.default.createElement(CompanySwitch_1.default, null)))))));
    }
    toggleMobileNav() {
        this.mobileNavHidden = !this.mobileNavHidden;
    }
    hideMobileNav() {
        this.mobileNavHidden = true;
    }
    toggleMobileSearch() {
        this.mobileSearchHidden = !this.mobileSearchHidden;
        window.requestAnimationFrame(() => {
            if (this.searchInputElement.current) {
                this.searchInputElement.current.focus();
            }
        });
    }
    hideMobileSearch() {
        this.mobileSearchHidden = true;
    }
    onSearchChange() {
        this.isSuggestionLoading = true;
        (0, dropdown_1.getProductSuggestions)(this.searchTerm)
            .then((products) => {
            this.suggestedProducts = products;
            this.showProductSuggestions = true;
        })
            .finally(() => (this.isSuggestionLoading = false));
    }
    onSearchClear() {
        (0, mobx_1.runInAction)(() => {
            this.searchTerm = '';
            this.showProductSuggestions = false;
            this.suggestedProducts = undefined;
        });
    }
    onSuggestionClick() {
        this.onSearchClear();
        this.hideMobileSearch();
    }
    isActive(item) {
        const path = this.props.location.pathname;
        const matchedRoute = (0, array_1.first)((0, react_router_config_1.matchRoutes)(Routes_1.default, path));
        return (matchedRoute?.route.path === item.path ||
            (0, react_router_config_1.matchRoutes)(matchedRoute?.route.routes ?? [], item.path).length === 1);
    }
    onShowProductSuggestions(event) {
        if (event.defaultPrevented) {
            return;
        }
        this.showProductSuggestions = false;
    }
}
__decorate([
    bind_decorator_1.default
], MainNavigation.prototype, "toggleMobileSearch", null);
__decorate([
    bind_decorator_1.default
], MainNavigation.prototype, "hideMobileSearch", null);
__decorate([
    bind_decorator_1.default
], MainNavigation.prototype, "onSearchChange", null);
__decorate([
    bind_decorator_1.default
], MainNavigation.prototype, "onSearchClear", null);
__decorate([
    bind_decorator_1.default
], MainNavigation.prototype, "onSuggestionClick", null);
__decorate([
    bind_decorator_1.default
], MainNavigation.prototype, "isActive", null);
exports.RawMainNavigation = MainNavigation;
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(MainNavigation));
